
///https://cdn.shopify.com/extensions/df121d8f-0913-4175-bf48-a2d9eede5956/zeno-currency-converter-13/assets/currency-converter.js
;(async function() {
	const IS_DEV = typeof module !== 'undefined'

	function currencyConverterRenderer({configs, currencies, moneyFormat, body, screen}) {
		// Configs
		let visibilityLg = configs['visibility-lg'] === 'true'
		let visibilitySm = configs['visibility-sm'] === 'true'
		let currencyList = configs['currencies']
		let position = configs['position']
		let fontSize = configs['font-size']
		let primaryColor = configs['color']
		let backgroundColor = configs['background-color']
		let zIndex = configs['z-index']
		let cssCode = configs['css-code']

		let decimalNumber = 2
		let decimalToken = '.'
		let separatorToken = ','
		let currencyPosition = 'left'
	
		if (moneyFormat.includes('amount_no_decimals')) {
			decimalNumber = 0
		} else if (moneyFormat.includes('amount_with_comma_separator')) {
			decimalNumber = 2
			decimalToken = ','
			separatorToken = '.'
		} else if (moneyFormat.includes('amount_no_decimals_with_comma_separator')) {
			decimalNumber = 0
			decimalToken = ','
			separatorToken = '.'
		} else if (moneyFormat.includes('amount_with_apostrophe_separator')) {
			decimalNumber = 0
			separatorToken = '\''
		}

		let currencySymbol = _extractContentFromHtml(moneyFormat.split('{{')[0])
		if (!currencySymbol) {
			currencyPosition = 'right'
		}

		let activeCurrencyCode = currencyList[0]

		_registerPolyfill()
		_render()

		function _render() {
			// Remove existing widget
			body.querySelectorAll('.currency-switcher  .zn-currency-converter').forEach(element => element.remove())
	
			if (!IS_DEV) {
				if (screen === 'lg' && !visibilityLg) return
				if (screen === 'sm' && !visibilitySm) return
			}

			let html = _makeHtml()
			let css = _makeCss()
			html.prepend(css)
	
			var _custom_panel = document.querySelector('.currency-switcher');
			//body.appendChild(html);
			if(_custom_panel)_custom_panel.appendChild(html);

			// Listen to default product variant change
			if (!IS_DEV) {
				let productForm = document.querySelector('form[action="/cart/add"]')
				let defaultIdInput = productForm ? productForm.querySelector('input[name="id"], select[name="id"]') : null
				if (defaultIdInput) {
					defaultIdInput.addEventListener('change', function() {
						let currencyHolder = html.querySelector(`.zn-available-currency[data-currency-code=${activeCurrencyCode}]`)
						if (currencyHolder) {
							setTimeout(function() {
								_changeCurrency(currencyHolder)
							}, 1000)
						}
				  })
				}
			}
		}

		function _makeHtml() {
			let wrapper = _makeDom('div', ['zn-currency-converter', 'zn-noselect','relative'], {
				'data-is-dev': IS_DEV,
				'data-screen': screen,
				'data-position': position,
				'style': `
					font-size: ${fontSize}px;
					color: ${primaryColor};
					background-color: ${backgroundColor};
					z-index: ${zIndex};
				`
			})

			let activeCurrency = _makeActiveCurrency()
			let availableCurrencies = _makeAvailableCurrencies()

			wrapper.appendChild(activeCurrency)
			wrapper.appendChild(availableCurrencies)

			return wrapper
		}

		function _makeActiveCurrency() {
			let activeCurrency = _makeDom('div', 'zn-active-currency', {
				'data-currency-code': activeCurrencyCode
			})

			let activeCurrencyFlag = _makeDom('div', ['zn-currency-flag', 'currency-flag', `currency-flag-${activeCurrencyCode.toLowerCase()}`])
			let activeCurrencyName = _makeDom('div', 'zn-currency-name', {
				innerText: activeCurrencyCode
			})

			activeCurrency.appendChild(activeCurrencyFlag)
			activeCurrency.appendChild(activeCurrencyName)
			activeCurrency.appendChild(_makeDom('i', 'zn-currency-caret', {
				innerText: ' ▼ ' // 'â–¼'
			}))

			document.addEventListener('click', (e) => {
				if (e.target.closest('.zn-currency-converter') || !activeCurrency.classList) return
				activeCurrency.classList.remove('active')
			})
	
			activeCurrency.addEventListener('click', function() {
				this.classList.toggle('active')
			})

			return activeCurrency
		}

		function _makeAvailableCurrencies() {
			let availableCurrencies = _makeDom('div', 'zn-available-currencies', {
				style: `
					background-color: ${backgroundColor};
				`
			})
			for (let currencyCode of currencyList) {
				let currency = currencies[currencyCode]
				let availableCurrency = _makeDom('div', 'zn-available-currency', {
					'data-currency-code': currencyCode,
					'data-currency-symbol': currency.symbol
				})

				let currencyFlag = _makeDom('div', ['zn-currency-flag', 'currency-flag', `currency-flag-${currencyCode.toLowerCase()}`])
				let currencyName = _makeDom('div', 'zn-currency-name', {
					innerHTML: `
						<span class="zn-code">${currencyCode}</span>
						<span class="zn-name">- ${currency.name}</span>
					`
				})

				availableCurrency.appendChild(currencyFlag)
				availableCurrency.appendChild(currencyName)

				if (!IS_DEV && localStorage.znCurrency == currencyCode) {
					setTimeout(function() {
						_changeCurrency(availableCurrency)
					}, 1000)
				}

				availableCurrency.addEventListener('click', function() {
					_changeCurrency(availableCurrency)
				})

				availableCurrencies.appendChild(availableCurrency)
			}

			return availableCurrencies
		}

		function _changeCurrency(currencyHolder) {
		_currencyHolder = currencyHolder;
			let wrapper = currencyHolder.closest('.zn-currency-converter');
			console.log("P",wrapper );

			let newCurrencyCode = currencyHolder.getAttribute('data-currency-code')
			let newCurrencySymbol = currencyHolder.getAttribute('data-currency-symbol')

			let activeCurrency = wrapper.querySelector('.zn-active-currency')
			let activeCurrencyFlag = activeCurrency.querySelector('.zn-currency-flag')
			let activeCurrencyName = activeCurrency.querySelector('.zn-currency-name')

			activeCurrency.classList.remove('active')
			activeCurrencyFlag.classList.remove('currency-flag-' + activeCurrencyCode.toLowerCase())
			activeCurrencyFlag.classList.add('currency-flag-' + newCurrencyCode.toLowerCase())
			activeCurrencyName.innerHTML = newCurrencyCode

			activeCurrencyCode = newCurrencyCode

			// Update prices
			const updateDefaultPrices = () => {
				let defaultProductPriceElements = document.querySelectorAll('.grid-link__org_price, .price-item, .product-single__price, .product-single__sale-price, .product-single__price--compare, .product-single__price--compare-at, .gp-price .money, .alchemy-rte span, .current_price .money, .was_price .money, .cpb-product-price')
				defaultProductPriceElements.forEach(function(element) {
					_updateDefaultProductPrice(element, {
						code: newCurrencyCode,
						symbol: newCurrencySymbol
					})
				})
			}

			updateDefaultPrices()

			// Support CPB
			let CPBButtons = document.querySelectorAll('.cpb-quantity-button, .btn_personalize')
			CPBButtons.forEach(button => {
				button.addEventListener('click', (e) => {
					setTimeout(() => {
						updateDefaultPrices()
					})
				})
			})

			if (!IS_DEV) {
				localStorage.znCurrency = newCurrencyCode

				if (window.znStorage) {
					document.querySelectorAll('.zn-element-wrapper[data-type="product-price"]').forEach(function(element) {
						let updateCurrency = window.znStorage.get(element, 'updateCurrency')
						if (updateCurrency) {
							updateCurrency({
								code: newCurrencyCode,
								symbol: newCurrencySymbol
							})
						}
					})
				}
			}
		}

		function _updateDefaultProductPrice(element, value) {
			let defaultCurrencyCode = window.znCCConfig.currencyCode
			let oldCurrencyCode = element.getAttribute('data-currency') || defaultCurrencyCode
			let priceText = element.innerText
			priceText = priceText.replace(new RegExp('\\' + separatorToken, 'g'), '')
			priceText = priceText.replace(new RegExp('\\' + decimalToken, 'g'), '.')

			let priceTextParts = priceText.split(' - ')
			let calculatedPriceParts = []
			for (let i = 0; i < priceTextParts.length; i++) {
				let priceText = priceTextParts[i]
				let priceTextMatches = /\d+(\.\d+)?/.exec(priceText)
				if (!priceTextMatches || priceTextMatches.length == 0) continue

				priceText = priceTextMatches[0]
				priceText = _calculatePrice(priceText, 1, oldCurrencyCode, value.code)

				if (priceText) {
					calculatedPriceParts.push(currencyPosition == 'right' ? priceText + value.symbol : value.symbol + priceText)
				}
			}
			
			if (calculatedPriceParts.length > 0) {
				element.innerText = calculatedPriceParts.join(' - ')
				element.setAttribute('data-currency', value.code)
			}
		}

		function _calculatePrice(price, quantity, defaultCurrencyCode, currencyCode) {
			if (!price) return ''

			price = parseFloat(price.replace(',', '.'))
	
			if (window.Currency) {
				price = window.Currency.convert(price, defaultCurrencyCode, currencyCode)
			}
			price *= quantity

			// Format
			price = Math.round(price * Math.pow(10, decimalNumber)) / Math.pow(10, decimalNumber)
			price = price + ''

			let priceParts = price.split('.')

			let priceIntegral = priceParts[0]
			let priceIntegralLength = priceIntegral.length
			let priceIntegralDigits = priceIntegral.split('')
			priceIntegral = ''
			for (let i = 0; i < priceIntegralLength; i++) {
				let digit = priceIntegralDigits[i]
				let periodIndex = (priceIntegralLength - i) % 3
		
				if (i != 0 && periodIndex == 0) {
					priceIntegral += separatorToken
				}
				priceIntegral += digit
			}

			let priceFractional = ((priceParts[1] || '') + '000000000000000000000000').slice(0, decimalNumber)

			if (decimalNumber > 0) {
				price = priceIntegral + decimalToken + priceFractional
			} else {
				price = priceIntegral
			}
			
			return price
		}

		function _makeCss() {
			return _makeDom('style', '', {
				innerText: cssCode
			})
		}
	}

	/**
	 * @param {string} tagName 
	 * @param {string|string[]} classNames 
	 * @param {object} attributes 
	 * @param {HTMLElement[]} children 
	 * @return {HTMLElement}
	 */
	function _makeDom(tagName, classNames = '', attributes = {}, children = []) {
		const el = document.createElement(tagName)
	
		if (Array.isArray(classNames)) {
			classNames = classNames.filter(className => className)
			el.classList.add(...classNames)
		} else if (classNames) {
			el.classList.add(classNames)
		}
	
		for (const attrName in attributes) {
			if (el[attrName] === undefined) {
				el.setAttribute(attrName, attributes[attrName])
			} else {
				el[attrName] = attributes[attrName]
			}
		}
	
		for (const child of children) {
			el.appendChild(child)
		}
	
		return el
	}

	/**
	 * @param {string} html 
	 */
	function _extractContentFromHtml(html) {
		let span = document.createElement('span')
		span.innerHTML = html
		let content = span.textContent || span.innerText
		return content.trim()
	}

	function _registerPolyfill() {
		if (!Element.prototype.matches) {
			Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
		}
		
		if (!Element.prototype.closest) {
			Element.prototype.closest = function (s) {
				let el = this
		
				if (!document.documentElement.contains(el)) return null
		
				do {
					if (el.matches(s)) return el
					el = el.parentElement || el.parentNode
				} while (el !== null && el.nodeType === 1)
		
				return null
			}
		}
	}

	_registerPolyfill()

	if (IS_DEV) {
		module.exports = {
			currencyConverterRenderer
		}
	} else {
		if (!window.znCCConfig || window.znCCConfig.template == 'cart') return

		let screen = window.innerWidth < 768 ? 'sm' : 'lg'
	
		let { configs, currencies, currencyCode, moneyFormat } = window.znCCConfig

		if (configs['detect-client'] === 'true') {
			let response = await fetch('https://ipapi.co/currency')
			let clientCurrencyCode = await response.text()

			if (currencies[clientCurrencyCode]) {
				if (!configs.currencies.includes(clientCurrencyCode)) {
					configs.currencies.unshift(clientCurrencyCode)
				}

				if (!localStorage.znCurrency) {
					localStorage.znCurrency = clientCurrencyCode
				}
			}
		}

		if (configs.currencies.includes(currencyCode)) {
			configs.currencies.splice(configs.currencies.indexOf(currencyCode), 1)
		}
		configs.currencies.unshift(currencyCode)

		currencyConverterRenderer({
			configs,
			currencies,
			moneyFormat,
			body: document.body,
			screen
		})
	}
})(); 